var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.875 10L17.3125 3.5625C17.5625 3.3125 17.5625 2.9375 17.3125 2.6875C17.0625 2.4375 16.6875 2.4375 16.4375 2.6875L10 9.125L3.5625 2.6875C3.3125 2.4375 2.9375 2.4375 2.6875 2.6875C2.4375 2.9375 2.4375 3.3125 2.6875 3.5625L9.125 10L2.6875 16.4375C2.4375 16.6875 2.4375 17.0625 2.6875 17.3125C2.8125 17.4375 3 17.5 3.125 17.5C3.25 17.5 3.4375 17.4375 3.5625 17.3125L10 10.875L16.4375 17.3125C16.5625 17.4375 16.75 17.5 16.875 17.5C17 17.5 17.1875 17.4375 17.3125 17.3125C17.5625 17.0625 17.5625 16.6875 17.3125 16.4375L10.875 10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconBlack);
export default __webpack_public_path__ + "static/media/closeIconBlack.68e80d7dee9ba6a3bc0373231d052c23.svg";
export { ForwardRef as ReactComponent };